import React from "react";
import ReactDOM from "react-dom";
import Routers from "./routes";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
//import HttpsRedirect from "react-https-redirect";
import "./app.css";

import { store, persistor } from "./store";

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      {/*<HttpsRedirect>*/}
        <Routers></Routers>
      {/*</HttpsRedirect>*/}
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);
